import React from "react";
import {MenuItem, Select} from "@mui/material";
import "./Dropdown.css";
import PropTypes from "prop-types";

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
      // paddingLeft: 10
    }
  }
};

const Dropdown = ({options, handleChange, selectedValue, label }) => {
  return (
    <div className="box" size="small">
      <label className="left" style={{marginRight: "10px"}}> {label}: </label>
      <Select
        displayEmpty
        className="right dropDownInput"
        value={selectedValue}
        onChange={handleChange}
        MenuProps={MenuProps}
        renderValue={(selected) => {
          if (selected === null || selected.length === 0) {
            return (
              <MenuItem className="menuItem" disabled value="">
                {`Select ${label}`}
              </MenuItem>
            );
          }
          return <p style={{textAlign: "left"}}>{selected}</p> ;
        }}
      >
        {options.map((option) => (
          <MenuItem
            className="menuItem"
            key={option.value}
            value={option.label}
          >
            <p className="menuOption">{option.label}</p>
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

Dropdown.propTypes = {
  options: PropTypes.array,
  handleChange: PropTypes.func,
  selectedValue: PropTypes.string,
  label: PropTypes.string
};

Dropdown.defaultProps = {
  options: [],
  handleChange: null,
  selectedValue: "",
  label: ""
};

export default Dropdown
